export default class {
    isPdf (filePath) {
        const type = this.extractTypeFromUrl(filePath);
        return type === 'application/pdf';
    }

    extractTypeFromUrl (filePath) {
        try {
            const urlObj = new URL(filePath, location.origin);
            return urlObj.searchParams.get('type');
        }
        catch (e) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/material/file/type/index.js